<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
// import { useRoute, useRouter } from 'vue-router';
// import { useToast } from 'primevue/usetoast';
import KpJahrSelect from '@/components/KpJahrSelect.vue';
import KpMandantKantonSelect from '@/components/KpMandantKantonSelect.vue';
import Toolbar from 'primevue/toolbar';
import Card from 'primevue/card';
import { ImportStatusCollection } from '@/models/ImportStatus';
import ImportStatusTimeline from '@/components/ImportStatusTimeline.vue';
import { instance as api, buildUrl } from '@/helpers/api';
import Button from 'primevue/button';

// const router = useRouter();
// const route = useRoute();
// const toast = useToast();

const kantonId = ref<number | null>(null);
const jahr = ref<number | null>(null);
const loading = ref<boolean | null>(null);

const collection = new ImportStatusCollection();

async function reloadCollection() {
    if (kantonId.value && jahr.value) {
        collection.setQueryParams({
            filter: [
                { property: 'kanton_id', value: kantonId.value },
                { property: 'jahr', value: jahr.value },
            ],
        });
        await collection.query();
    }
}

const gebSteps = [
    { name: 'import_gwr_daten' },
    { name: 'import_angrenzende_gebaeude' },
    { name: 'import_grossverbraucher' },
    { name: 'calc_gebaeude_liste' },
    { name: 'calc_energieverbrauch' },
];
const prodSteps = [
    { name: 'import_eingespeiste_energie' },
    { name: 'import_produktionseinheiten' },
    { name: 'import_solarstromanlagen' },
    { name: 'calc_liste_stromerzeugungsanlagen' },
];

let timer: number | null = null;
onMounted(async () => {
    timer = setInterval(async () => {
        reloadCollection();
    }, 10000);
});

onBeforeUnmount(() => {
    if (timer) {
        clearInterval(timer);
    }
});

const onRecalculate = async () => {
    await api().post('/ImportStatus/recalc', {
        jahr: jahr.value,
        kanton_id: kantonId.value,
    });
};

const downloadHinweismeldungen = (controller: string) => {
    if (!jahr.value || !kantonId.value) {
        return;
    }
    const url = buildUrl(`/${controller}/downloadHinweismeldungen`, {
        jahr: jahr.value,
        kanton_id: kantonId.value,
    });
    window.open(url, '_blank');
};

watch(kantonId, () => reloadCollection());
watch(jahr, () => reloadCollection());
</script>
<template>
    <Card class="kp-max-content-width">
        <template #header>
            <Toolbar class="toolbar border-none">
                <template #start>
                    <h2>{{ $t('status_berechnungen') }}</h2>
                </template>
            </Toolbar>
        </template>
        <template #content>
            <div class="mb-1rem">{{ $t('bitte_filter_waehlen') }}</div>
            <div class="formgrid grid align-items-start">
                <KpMandantKantonSelect
                    class="col-3"
                    v-model="kantonId"
                    fluid
                    :label="$t('kanton')"
                    :disabled="loading"
                ></KpMandantKantonSelect>
                <KpJahrSelect
                    class="col-3"
                    v-model="jahr"
                    fluid
                    :label="$t('jahr')"
                    :start-year="2023"
                    :disabled="loading"
                ></KpJahrSelect>
            </div>
            <template v-if="collection.getModels().length === 1">
                <div class="flex align-items-center gap-1rem">
                    <Button
                        type="button"
                        :label="$t('listen_neu_erstellen')"
                        severity="primary"
                        @click="onRecalculate"
                    ></Button>
                    <span class="text-surface-500 dark:text-surface-400 text-sm">
                        {{ $t('listen_neu_erstellen_hinweis') }}
                    </span>
                </div>
                <div class="formgrid grid align-items-start">
                    <div class="flex-auto">
                        <h4 class="text-center">{{ $t('gebaeude') }}</h4>
                        <ImportStatusTimeline
                            :status="collection.getModels()[0]"
                            :steps="gebSteps"
                        ></ImportStatusTimeline>
                        <div class="text-center mt-1rem">
                            <Button
                                type="button"
                                :label="$t('hinweismeldungen_herunterladen')"
                                icon="fa-solid fa-download"
                                severity="secondary"
                                text
                                @click="downloadHinweismeldungen('GesamtenergieverbrauchProGebaeude')"
                            ></Button>
                        </div>
                    </div>
                    <div class="flex-auto">
                        <h4 class="text-center">{{ $t('produktion') }}</h4>
                        <ImportStatusTimeline
                            :status="collection.getModels()[0]"
                            :steps="prodSteps"
                        ></ImportStatusTimeline>
                        <div class="text-center mt-1rem">
                            <Button
                                type="button"
                                :label="$t('hinweismeldungen_herunterladen')"
                                icon="fa-solid fa-download"
                                severity="secondary"
                                text
                                @click="downloadHinweismeldungen('Stromerzeugungsanlagen')"
                            ></Button>
                        </div>
                    </div>
                </div>
            </template>
            <div v-else-if="jahr && kantonId">{{ $t('keine_daten_fuer_jahr_kt') }}</div>
        </template>
    </Card>
</template>
